import { Typography, withStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";

const styles = (theme) => {
  const colors = Object.entries(theme.colors).reduce(
    (obj, [key, val]) => ({ ...obj, [key]: { color: val } }),
    {},
  );

  return {
    text: {
      fontSize: 16,
      lineHeight: "16px",
      fontFamily: "Larsseit-Light",
      "& b": {
        fontFamily: "Larsseit-Bold",
        fontStyle: "normal",
      },
      "& i": {
        fontFamily: "Larsseit",
        fontStyle: "normal",
      },
      "& strong": {
        fontFamily: "Larsseit-Medium",
        fontStyle: "normal",
        fontWeight: "normal",
      },
    },
    ellipsis: {
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
    multiline: {
      lineHeight: "24px",
      "& > i": {
        fontFamily: "Larsseit-Medium",
        fontStyle: "normal",
      },
    },
    obscure: {
      filter: "blur(3px)",
      userSelect: "none",
    },
    ...colors,
  };
};

function H4({ children, classes, ...props }) {
  const classnames = Object.keys(props)
    .map((k) => props[k] && classes[k])
    .join(" ");

  return (
    <Typography component="h4" className={`${classes.text} ${classnames}`}>
      {children}
    </Typography>
  );
}

H4.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  classes: PropTypes.object.isRequired,
};

export default React.memo(withStyles(styles)(H4));
